// import './services/fetch';
// import './fixtures';
import Vue from 'vue';
import 'spa-ionata-admin/lib/services/asyncWait';
import './lang.ts';
import { ApplicationRecord } from 'spa-ionata-admin/lib/models';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import {
  apiBase,
  apiNamespace,
  appVersion,
  baseUrl,
  isDev,
  project,
  useCookies,
} from './config';
import router from './router';
import store, { settingsModule } from './store';
import LocaleItem from './services/LocaleItem';
import App from './App.vue';
import langService from 'spa-ionata-admin/lib/services/Languages';
import './registerServiceWorker';
import { registerModels } from './models/registerModels';
import User from './models/User';

Vue.config.productionTip = false;

// Ensure user-persisted language is pre-set
langService.selectedCode = settingsModule.lang;

ApplicationRecord.setup({
  apiBase,
  apiNamespace,
  useCookies,
  appVersion,
  project,
});

// if (isDev) {
//   ApplicationRecord.fetchSchema();
// }

User.supportsPermissions = true;

registerModels();

LocaleItem.debug = isDev;
LocaleItem.getLang = () => settingsModule.lang;

if (isDev) {
  window.console.log('apiBase:', apiBase);
  window.console.log('baseUrl:', baseUrl);
  window.console.log(process.env);
}
if (window.console) {
  window.console.log('App version:', appVersion);
}

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
